import { Unit } from 'uom';
import { Units } from 'uom-units';

export const Psi = Unit.timesNumber(
    'psi',
    6894.76,
    Units.Pascal,
);
